import { Pipe, PipeTransform } from "@angular/core";
import { LookerStudioService } from "../services/looker-studio.service";

@Pipe({
  standalone: true,
  name: "prettifyAttribute",
})
export class PrettifyAttributePipe implements PipeTransform {
  constructor(private looker: LookerStudioService) {}

  transform(before: string): string {
    return this.looker.prettifyAttribute(before);
  }
}
